<template>
  <div class="content-detail-toggle">
    <icon-button
      type="button"
      class="-ico-only -no-container"
      :icon="isExpanded(expandContentId) ? 'horizontal_rule' : 'horizontal_rule'"
      :label="isExpanded(expandContentId) ? 'Details Expanded' : 'Details Collapsed'"
      :aria-expanded="isExpanded(expandContentId) ? 'true' : 'false'"
      :aria-controls="expandContentId"
      @click-action="handleExpandToggle"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { useExpandersStore } from '@/stores/expanders'
import IconButton from '@/components/buttons/icon-button.vue'

/**
 * Generic expand toggle that uses pinia to open an expander that is not
 * connected in the DOM.
 *
 * NOTE: Should be coupled with expand-details-stats-content.vue with
 * matching ID
 */
export default {
  name: 'ExpandStatsToggle',
  components: { IconButton },
  props: {
    expandContentId: {
      type: String,
      required: true,
    },

    collapseAll: {
      type: Boolean,
      default: true,
    },

    // used to init expanded if screen size is large
    largeScreenExpanded: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {}
  },

  computed: {
    ...mapState(useExpandersStore, ['isExpanded']),
  },

  created() {
    // expand by default if on large screen
    if (this.largeScreenExpanded && this.largeScreenCheck()) {
      this.setExpanded({
        id: this.expandContentId,
        expanded: true,
        collapseAll: this.collapseAll,
      })
    }
  },

  methods: {
    ...mapActions(useExpandersStore, ['setExpanded']),

    // pinia will handle state change
    handleExpandToggle() {
      this.setExpanded({
        id: this.expandContentId,
        expanded: !this.isExpanded(this.expandContentId),
        collapseAll: this.collapseAll,
      })
    },

    largeScreenCheck() {
      // desktop > 600
      if (window.innerWidth >= 600) {
        return true
      }

      // mobile < 600
      return false
    },
  },
}
</script>
